import React, { useContext } from 'react';
import { StudioContext, StudioSidePanelContext } from 'venn-components';
import type { AnalysisView } from 'venn-api';
import StudioRightPanelContent from './StudioRightPanelContent';

const StudioRightPanel = React.memo(function StudioRightPanel() {
  const { analysisView } = useContext(StudioContext);
  const { onSelectGlobal, onSelectBlock } = useContext(StudioSidePanelContext);

  return (
    <StudioRightPanelContent
      openStudioSetup={onSelectGlobal}
      globalView={analysisView ?? ({} as AnalysisView)}
      onSelectBlock={onSelectBlock}
    />
  );
});

export default StudioRightPanel;
